import { api } from '../middleware/api';

export interface AmDocument {
  ed_id?: number;
  ed_company?: string;
  ed_asset?: number;
  ed_reftype?: string;
  ed_refid?: number;
  ed_refline?: number | null;
  ed_filename: string;
  ed_filetype?: string;
  ed_filesize?: number;
  ed_category?: string;
  ed_uid?: string;
  ed_cdt?: string;
}

export const amdocumentApi = api
  .enhanceEndpoints({ addTagTypes: ['AmDocument', 'AmAsset'] })
  .injectEndpoints({
    endpoints: builder => ({
      getAmDocuments: builder.query<AmDocument[], number>({
        query: (assetId) => `amdocument/${assetId}`,
        providesTags: ['AmDocument']
      }),
      uploadAmDocument: builder.mutation<{ ed_id: number }, FormData>({
        query: (body) => ({
          url: 'amdocument',
          method: 'POST',
          body
        }),
        invalidatesTags: ['AmDocument', 'AmAsset']
      }),
      deleteAmDocument: builder.mutation<{ message: string }, number>({
        query: (id) => ({
          url: `amdocument/${id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['AmDocument', 'AmAsset']
      })
    }),
    overrideExisting: false
  });

export const {
  useGetAmDocumentsQuery,
  useUploadAmDocumentMutation,
  useDeleteAmDocumentMutation
} = amdocumentApi;
